"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-top: ", ";\n  margin-left: auto;\n  justify-content: flex-start;\n  ", " {\n    justify-content: flex-end;\n    margin-top: ", ";\n  }\n  > button:not(:last-child) {\n    margin-right: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  margin-right: ", ";\n  cursor: pointer;\n  transition: color 0.1s linear;\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-right: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeader = void 0;

var icons_1 = require("@ant-design/icons");

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Block_1 = require("./Block");

var Typography_1 = require("./Typography");

var responsive_1 = require("./responsive");

var TitleContainer = styled_components_1.default.div(_templateObject(), function (props) {
  return props.theme['@size-s'];
});
var Icon = (0, styled_components_1.default)(icons_1.ArrowLeftOutlined)(_templateObject2(), function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@gray-5'];
}, function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@gray-7'];
});
var ActionsContainer = styled_components_1.default.div(_templateObject3(), function (props) {
  return props.theme['@PageHeader-topMargin'] || props.theme['@size-s'];
}, responsive_1.media.md, function (props) {
  return props.theme['@PageHeader-topMargin'] || 0;
}, function (props) {
  return props.theme['@size-xs'];
});
var Container = styled_components_1.default.div(_templateObject4());

var PageHeader = function PageHeader(_ref) {
  var title = _ref.title,
      onBack = _ref.onBack,
      children = _ref.children,
      subtitle = _ref.subtitle;
  return react_1.default.createElement(Block_1.Block, {
    marginBottom: true
  }, react_1.default.createElement(Container, null, react_1.default.createElement(TitleContainer, null, onBack ? react_1.default.createElement(Icon, {
    onClick: onBack
  }) : null, react_1.default.createElement("div", null, react_1.default.createElement(Typography_1.H1, {
    isBlock: false
  }, title), subtitle ? react_1.default.createElement(Typography_1.H1Subtitle, {
    isBlock: false
  }, subtitle) : null)), react_1.default.createElement(ActionsContainer, null, children)));
};

exports.PageHeader = PageHeader;